function initCustomerReviews(root = document) {
  root.querySelectorAll('[data-tsl-review-clamp]').forEach((wrap) => {
    if (wrap.dataset.initialized === 'true') return;

    const textEl = wrap.querySelector('[data-tsl-review-text]');
    const toggle = wrap.querySelector('[data-tsl-review-toggle]');
    if (!textEl || !toggle) return;

    wrap.dataset.initialized = 'true';

    const readMore = toggle.dataset.readMore || 'Read more';
    const readLess = toggle.dataset.readLess || 'Read less';

    const syncToggle = () => {
      const isExpanded = wrap.classList.contains('tsl-customer-review__text-wrap--expanded');
      const overflows = textEl.scrollHeight > textEl.clientHeight + 1;

      if (isExpanded) {
        toggle.hidden = false;
        toggle.textContent = readLess;
        return;
      }

      toggle.hidden = !overflows;
      toggle.textContent = readMore;
    };

    toggle.addEventListener('click', () => {
      wrap.classList.toggle('tsl-customer-review__text-wrap--expanded');
      syncToggle();
    });

    syncToggle();
    window.addEventListener('resize', syncToggle, { passive: true });
  });
}

document.addEventListener('DOMContentLoaded', () => initCustomerReviews());
document.addEventListener('shopify:section:load', (event) => initCustomerReviews(event.target));
